// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__t2aIq","content":"card_content__36R82","image":"card_image__2KT3W","diets":"card_diets__10pm3"};